import type { Instrument } from "./types";

export type MidiNoteMap = Record<number, Instrument>;

/** General MIDI Drum Map (standard) */
export const DEFAULT_MIDI_MAP: MidiNoteMap = {
  35: "kick",
  36: "kick",
  38: "snare",
  40: "snare",
  42: "hihat",
  44: "pedalhat",
  46: "openhihat",
  48: "hitom",
  45: "midtom",
  41: "lotom",
  43: "lotom",
  49: "crash",
  57: "crash",
  51: "ride",
  59: "ride",
  55: "splash",
};

const STORAGE_KEY = "drumflow-midi-mapping";
const LATENCY_KEY = "drumflow-midi-latency";

export function loadMidiLatency(): number {
  try {
    const val = localStorage.getItem(LATENCY_KEY);
    if (val !== null) return Number(val) || 0;
  } catch {}
  return 0;
}

export function saveMidiLatency(ms: number): void {
  localStorage.setItem(LATENCY_KEY, String(ms));
}

export function loadMidiMapping(): MidiNoteMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      // Convert string keys back to numbers
      const map: MidiNoteMap = {};
      for (const [k, v] of Object.entries(parsed)) {
        map[Number(k)] = v as Instrument;
      }
      return map;
    }
  } catch {}
  return { ...DEFAULT_MIDI_MAP };
}

export function saveMidiMapping(map: MidiNoteMap): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

/** Get human-readable MIDI note name (e.g. "C3", "D#4") */
export function midiNoteName(note: number): string {
  const names = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
  const octave = Math.floor(note / 12) - 1;
  return `${names[note % 12]}${octave}`;
}
